export const PAYMENT_REQUEST_STATUS = {
  requested: "requested",
  declined: "declined",
  cancelledClient: "cancelled_client",
  cancelledProvider: "cancelled_provider",
  refundedProvider: "refunded_provider",
  paid: "paid",
} as const

export type PaymentRequestStatus =
  (typeof PAYMENT_REQUEST_STATUS)[keyof typeof PAYMENT_REQUEST_STATUS]

export type CommonPaymentRequest = {
  ident: string
  customer: {
    id: string
    name: string
    email: string
    phone: string
    description: string
  }
  user: string | null
  amountNet: number
  amountGross: number
  amountVat: number
  customerCreated: boolean
  description: string
  status: PaymentRequestStatus
  createdAt: Date
  lastSentAt: Date | null
}
